// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension="
// @generated from file container/v1/container.proto (package container.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from '@bufbuild/protobuf/codegenv2'
import { enumDesc, fileDesc, messageDesc, serviceDesc } from '@bufbuild/protobuf/codegenv2'
import type { CreationMethod, DateRange } from '../../asset/v1/asset_pb'
import { file_asset_v1_asset } from '../../asset/v1/asset_pb'
import { file_common_v1_annotations } from '../../common/v1/annotations_pb'
import type { PaginationArguments, PaginationPageInfo } from '../../common/v1/pagination_pb'
import { file_common_v1_pagination } from '../../common/v1/pagination_pb'
import { file_google_api_annotations } from '../../google/api/annotations_pb'
import type { Timestamp } from '@bufbuild/protobuf/wkt'
import { file_google_protobuf_timestamp } from '@bufbuild/protobuf/wkt'
import type { Message } from '@bufbuild/protobuf'

/**
 * Describes the file container/v1/container.proto.
 */
export const file_container_v1_container: GenFile =
  /*@__PURE__*/
  fileDesc(
    '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',
    [
      file_asset_v1_asset,
      file_common_v1_annotations,
      file_common_v1_pagination,
      file_google_api_annotations,
      file_google_protobuf_timestamp
    ]
  )

/**
 * @generated from message container.v1.Folder
 */
export type Folder = Message<'container.v1.Folder'> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string

  /**
   * @generated from field: string name = 2;
   */
  name: string

  /**
   * @generated from field: string description = 3;
   */
  description: string

  /**
   * @generated from field: string path = 4;
   */
  path: string

  /**
   * @generated from field: string creator_id = 5;
   */
  creatorId: string

  /**
   * @generated from field: string owner_id = 6;
   */
  ownerId: string

  /**
   * @generated from field: container.v1.ContainerType container_type = 7;
   */
  containerType: ContainerType

  /**
   * @generated from field: container.v1.FolderState state = 8;
   */
  state: FolderState

  /**
   * @generated from field: asset.v1.CreationMethod creation_method = 9;
   */
  creationMethod: CreationMethod

  /**
   * @generated from field: repeated string tags = 10;
   */
  tags: string[]

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 11;
   */
  createdAt?: Timestamp

  /**
   * @generated from field: optional google.protobuf.Timestamp updated_at = 12;
   */
  updatedAt?: Timestamp

  /**
   * @generated from field: optional google.protobuf.Timestamp archived_at = 17;
   */
  archivedAt?: Timestamp

  /**
   * @generated from field: int32 num_folders = 13;
   */
  numFolders: number

  /**
   * @generated from field: int32 num_assets = 14;
   */
  numAssets: number

  /**
   * @generated from field: string org_id = 15;
   */
  orgId: string

  /**
   * @generated from field: string workspace_id = 16;
   */
  workspaceId: string
}

/**
 * Describes the message container.v1.Folder.
 * Use `create(FolderSchema)` to create a new message.
 */
export const FolderSchema: GenMessage<Folder> =
  /*@__PURE__*/
  messageDesc(file_container_v1_container, 0)

/**
 * @generated from message container.v1.Workspace
 */
export type Workspace = Message<'container.v1.Workspace'> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string

  /**
   * @generated from field: string name = 2;
   */
  name: string

  /**
   * @generated from field: string description = 3;
   */
  description: string

  /**
   * @generated from field: string path = 4;
   */
  path: string

  /**
   * @generated from field: string creator_id = 5;
   */
  creatorId: string

  /**
   * @generated from field: container.v1.ContainerType container_type = 6;
   */
  containerType: ContainerType

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */
  createdAt?: Timestamp

  /**
   * @generated from field: optional google.protobuf.Timestamp updated_at = 8;
   */
  updatedAt?: Timestamp

  /**
   * @generated from field: asset.v1.CreationMethod creation_method = 9;
   */
  creationMethod: CreationMethod

  /**
   * @generated from field: int32 num_folders = 10;
   */
  numFolders: number

  /**
   * @generated from field: int32 num_assets = 11;
   */
  numAssets: number

  /**
   * @generated from field: string org_id = 12;
   */
  orgId: string
}

/**
 * Describes the message container.v1.Workspace.
 * Use `create(WorkspaceSchema)` to create a new message.
 */
export const WorkspaceSchema: GenMessage<Workspace> =
  /*@__PURE__*/
  messageDesc(file_container_v1_container, 1)

/**
 * @generated from message container.v1.Org
 */
export type Org = Message<'container.v1.Org'> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string

  /**
   * @generated from field: string name = 2;
   */
  name: string

  /**
   * @generated from field: string description = 3;
   */
  description: string

  /**
   * @generated from field: string path = 4;
   */
  path: string

  /**
   * @generated from field: string creator_id = 5;
   */
  creatorId: string

  /**
   * @generated from field: container.v1.ContainerType container_type = 6;
   */
  containerType: ContainerType

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */
  createdAt?: Timestamp

  /**
   * @generated from field: optional google.protobuf.Timestamp updated_at = 8;
   */
  updatedAt?: Timestamp

  /**
   * @generated from field: asset.v1.CreationMethod creation_method = 9;
   */
  creationMethod: CreationMethod

  /**
   * @generated from field: int32 num_workspaces = 10;
   */
  numWorkspaces: number

  /**
   * @generated from field: int32 num_assets = 11;
   */
  numAssets: number
}

/**
 * Describes the message container.v1.Org.
 * Use `create(OrgSchema)` to create a new message.
 */
export const OrgSchema: GenMessage<Org> = /*@__PURE__*/ messageDesc(file_container_v1_container, 2)

/**
 * @generated from message container.v1.GetOrgRequest
 */
export type GetOrgRequest = Message<'container.v1.GetOrgRequest'> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string
}

/**
 * Describes the message container.v1.GetOrgRequest.
 * Use `create(GetOrgRequestSchema)` to create a new message.
 */
export const GetOrgRequestSchema: GenMessage<GetOrgRequest> =
  /*@__PURE__*/
  messageDesc(file_container_v1_container, 3)

/**
 * @generated from message container.v1.GetWorkspaceRequest
 */
export type GetWorkspaceRequest = Message<'container.v1.GetWorkspaceRequest'> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string
}

/**
 * Describes the message container.v1.GetWorkspaceRequest.
 * Use `create(GetWorkspaceRequestSchema)` to create a new message.
 */
export const GetWorkspaceRequestSchema: GenMessage<GetWorkspaceRequest> =
  /*@__PURE__*/
  messageDesc(file_container_v1_container, 4)

/**
 * @generated from message container.v1.GetFolderRequest
 */
export type GetFolderRequest = Message<'container.v1.GetFolderRequest'> & {
  /**
   * @generated from oneof container.v1.GetFolderRequest.id
   */
  id:
    | {
        /**
         * @generated from field: string folder_id = 1;
         */
        value: string
        case: 'folderId'
      }
    | {
        /**
         * @generated from field: string folder_path = 2;
         */
        value: string
        case: 'folderPath'
      }
    | { case: undefined; value?: undefined }
}

/**
 * Describes the message container.v1.GetFolderRequest.
 * Use `create(GetFolderRequestSchema)` to create a new message.
 */
export const GetFolderRequestSchema: GenMessage<GetFolderRequest> =
  /*@__PURE__*/
  messageDesc(file_container_v1_container, 5)

/**
 * @generated from message container.v1.ListWorkspacesRequest
 */
export type ListWorkspacesRequest = Message<'container.v1.ListWorkspacesRequest'> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string

  /**
   * @generated from field: optional common.v1.PaginationArguments paginate = 2;
   */
  paginate?: PaginationArguments
}

/**
 * Describes the message container.v1.ListWorkspacesRequest.
 * Use `create(ListWorkspacesRequestSchema)` to create a new message.
 */
export const ListWorkspacesRequestSchema: GenMessage<ListWorkspacesRequest> =
  /*@__PURE__*/
  messageDesc(file_container_v1_container, 6)

/**
 * @generated from message container.v1.FolderFilter
 */
export type FolderFilter = Message<'container.v1.FolderFilter'> & {
  /**
   * returns folders only in the provides states
   *
   * @generated from field: repeated container.v1.FolderState states = 1;
   */
  states: FolderState[]

  /**
   * returns folders by the creator(s)
   *
   * @generated from field: repeated string creator_ids = 2;
   */
  creatorIds: string[]

  /**
   * returns folders by the owner(s)
   *
   * @generated from field: repeated string owner_ids = 3;
   */
  ownerIds: string[]

  /**
   * CreatedAtDateRange scopes the response to folders created in the specified range. The filter is exclusive
   *
   * When start_date is empty the filtering will get everything created up to end_date
   * When end_date is empty the filtering will get everything created from the start_date up until now
   *
   * @generated from field: optional asset.v1.DateRange created_at_date_range = 4;
   */
  createdAtDateRange?: DateRange

  /**
   * returns folders that match the supplied name prefix
   *
   * @generated from field: string name_prefix = 5;
   */
  namePrefix: string

  /**
   * This argument determines how many layers of nested folders should be returned
   *
   * - The default behavior is 1, and returns only the folders direct children
   * - If -1 is used, all folders and their subfolders will be returned
   *
   * @generated from field: int32 depth = 6;
   */
  depth: number
}

/**
 * Describes the message container.v1.FolderFilter.
 * Use `create(FolderFilterSchema)` to create a new message.
 */
export const FolderFilterSchema: GenMessage<FolderFilter> =
  /*@__PURE__*/
  messageDesc(file_container_v1_container, 7)

/**
 * @generated from message container.v1.ListFoldersRequest
 */
export type ListFoldersRequest = Message<'container.v1.ListFoldersRequest'> & {
  /**
   * @generated from oneof container.v1.ListFoldersRequest.id
   */
  id:
    | {
        /**
         * @generated from field: string org_id = 1;
         */
        value: string
        case: 'orgId'
      }
    | {
        /**
         * @generated from field: string workspace_id = 2;
         */
        value: string
        case: 'workspaceId'
      }
    | {
        /**
         * @generated from field: string folder_id = 3;
         */
        value: string
        case: 'folderId'
      }
    | { case: undefined; value?: undefined }

  /**
   * @generated from field: optional common.v1.PaginationArguments paginate = 4;
   */
  paginate?: PaginationArguments

  /**
   * @generated from field: optional container.v1.FolderFilter filter = 5;
   */
  filter?: FolderFilter
}

/**
 * Describes the message container.v1.ListFoldersRequest.
 * Use `create(ListFoldersRequestSchema)` to create a new message.
 */
export const ListFoldersRequestSchema: GenMessage<ListFoldersRequest> =
  /*@__PURE__*/
  messageDesc(file_container_v1_container, 8)

/**
 * @generated from message container.v1.CountFoldersRequest
 */
export type CountFoldersRequest = Message<'container.v1.CountFoldersRequest'> & {
  /**
   * @generated from oneof container.v1.CountFoldersRequest.id
   */
  id:
    | {
        /**
         * @generated from field: string org_id = 1;
         */
        value: string
        case: 'orgId'
      }
    | {
        /**
         * @generated from field: string workspace_id = 2;
         */
        value: string
        case: 'workspaceId'
      }
    | {
        /**
         * @generated from field: string folder_id = 3;
         */
        value: string
        case: 'folderId'
      }
    | { case: undefined; value?: undefined }

  /**
   * @generated from field: optional container.v1.FolderFilter filter = 5;
   */
  filter?: FolderFilter
}

/**
 * Describes the message container.v1.CountFoldersRequest.
 * Use `create(CountFoldersRequestSchema)` to create a new message.
 */
export const CountFoldersRequestSchema: GenMessage<CountFoldersRequest> =
  /*@__PURE__*/
  messageDesc(file_container_v1_container, 9)

/**
 * @generated from message container.v1.CreateFolderRequest
 */
export type CreateFolderRequest = Message<'container.v1.CreateFolderRequest'> & {
  /**
   * ID is an optional bring your own id for the folder
   *
   * @generated from field: string id = 1;
   */
  id: string

  /**
   * Name is the name used when displaying the folder
   *
   * - The folder's path is derived by appending the name to the parent path seperated by "/"
   *
   * @generated from field: string name = 4;
   */
  name: string

  /**
   * ParentPath represents the path of the org, workspace, or folder the new folder should be placed in
   *
   * - If the parent_path is empty then the folder is placed at the root in the user's org
   *
   * @generated from field: string parent_path = 2;
   */
  parentPath: string

  /**
   * State is a required field to create create the folder in the supplied FolderState
   *
   * - Default is that the folder is created in the active state
   *
   * @generated from field: container.v1.FolderState state = 3;
   */
  state: FolderState

  /**
   * Description is an optional description associated to the folder.
   *
   * @generated from field: optional string description = 5;
   */
  description?: string

  /**
   * Tags associated to the folder
   *
   * @generated from field: repeated string tags = 6;
   */
  tags: string[]

  /**
   * @generated from field: asset.v1.CreationMethod creation_method = 7;
   */
  creationMethod: CreationMethod

  /**
   * @generated from field: string owner_id = 8;
   */
  ownerId: string
}

/**
 * Describes the message container.v1.CreateFolderRequest.
 * Use `create(CreateFolderRequestSchema)` to create a new message.
 */
export const CreateFolderRequestSchema: GenMessage<CreateFolderRequest> =
  /*@__PURE__*/
  messageDesc(file_container_v1_container, 10)

/**
 * @generated from message container.v1.UpdateFolderRequest
 */
export type UpdateFolderRequest = Message<'container.v1.UpdateFolderRequest'> & {
  /**
   * The id of the folder
   *
   * @generated from field: string id = 1;
   */
  id: string

  /**
   * Optionally update the folder name
   *
   * @generated from field: optional string name = 3;
   */
  name?: string

  /**
   * Optionally update the folder description
   *
   * @generated from field: optional string description = 4;
   */
  description?: string

  /**
   * Optionally update the owner
   *
   * @generated from field: optional string owner_id = 5;
   */
  ownerId?: string
}

/**
 * Describes the message container.v1.UpdateFolderRequest.
 * Use `create(UpdateFolderRequestSchema)` to create a new message.
 */
export const UpdateFolderRequestSchema: GenMessage<UpdateFolderRequest> =
  /*@__PURE__*/
  messageDesc(file_container_v1_container, 11)

/**
 * @generated from message container.v1.ArchiveFolderRequest
 */
export type ArchiveFolderRequest = Message<'container.v1.ArchiveFolderRequest'> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string
}

/**
 * Describes the message container.v1.ArchiveFolderRequest.
 * Use `create(ArchiveFolderRequestSchema)` to create a new message.
 */
export const ArchiveFolderRequestSchema: GenMessage<ArchiveFolderRequest> =
  /*@__PURE__*/
  messageDesc(file_container_v1_container, 12)

/**
 * @generated from message container.v1.RestoreFolderRequest
 */
export type RestoreFolderRequest = Message<'container.v1.RestoreFolderRequest'> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string
}

/**
 * Describes the message container.v1.RestoreFolderRequest.
 * Use `create(RestoreFolderRequestSchema)` to create a new message.
 */
export const RestoreFolderRequestSchema: GenMessage<RestoreFolderRequest> =
  /*@__PURE__*/
  messageDesc(file_container_v1_container, 13)

/**
 * @generated from message container.v1.DeleteFolderRequest
 */
export type DeleteFolderRequest = Message<'container.v1.DeleteFolderRequest'> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string
}

/**
 * Describes the message container.v1.DeleteFolderRequest.
 * Use `create(DeleteFolderRequestSchema)` to create a new message.
 */
export const DeleteFolderRequestSchema: GenMessage<DeleteFolderRequest> =
  /*@__PURE__*/
  messageDesc(file_container_v1_container, 14)

/**
 * @generated from message container.v1.DeleteFoldersRequest
 */
export type DeleteFoldersRequest = Message<'container.v1.DeleteFoldersRequest'> & {
  /**
   * @generated from field: repeated string ids = 1;
   */
  ids: string[]
}

/**
 * Describes the message container.v1.DeleteFoldersRequest.
 * Use `create(DeleteFoldersRequestSchema)` to create a new message.
 */
export const DeleteFoldersRequestSchema: GenMessage<DeleteFoldersRequest> =
  /*@__PURE__*/
  messageDesc(file_container_v1_container, 15)

/**
 * @generated from message container.v1.MoveFolderRequest
 */
export type MoveFolderRequest = Message<'container.v1.MoveFolderRequest'> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string

  /**
   * @generated from field: string parent_path = 2;
   */
  parentPath: string
}

/**
 * Describes the message container.v1.MoveFolderRequest.
 * Use `create(MoveFolderRequestSchema)` to create a new message.
 */
export const MoveFolderRequestSchema: GenMessage<MoveFolderRequest> =
  /*@__PURE__*/
  messageDesc(file_container_v1_container, 16)

/**
 * @generated from message container.v1.MoveFoldersRequest
 */
export type MoveFoldersRequest = Message<'container.v1.MoveFoldersRequest'> & {
  /**
   * @generated from field: repeated string ids = 1;
   */
  ids: string[]

  /**
   * @generated from field: string parent_path = 2;
   */
  parentPath: string
}

/**
 * Describes the message container.v1.MoveFoldersRequest.
 * Use `create(MoveFoldersRequestSchema)` to create a new message.
 */
export const MoveFoldersRequestSchema: GenMessage<MoveFoldersRequest> =
  /*@__PURE__*/
  messageDesc(file_container_v1_container, 17)

/**
 * @generated from message container.v1.GetOrgResponse
 */
export type GetOrgResponse = Message<'container.v1.GetOrgResponse'> & {
  /**
   * @generated from field: container.v1.Org org = 1;
   */
  org?: Org
}

/**
 * Describes the message container.v1.GetOrgResponse.
 * Use `create(GetOrgResponseSchema)` to create a new message.
 */
export const GetOrgResponseSchema: GenMessage<GetOrgResponse> =
  /*@__PURE__*/
  messageDesc(file_container_v1_container, 18)

/**
 * @generated from message container.v1.GetWorkspaceResponse
 */
export type GetWorkspaceResponse = Message<'container.v1.GetWorkspaceResponse'> & {
  /**
   * @generated from field: container.v1.Workspace workspace = 1;
   */
  workspace?: Workspace
}

/**
 * Describes the message container.v1.GetWorkspaceResponse.
 * Use `create(GetWorkspaceResponseSchema)` to create a new message.
 */
export const GetWorkspaceResponseSchema: GenMessage<GetWorkspaceResponse> =
  /*@__PURE__*/
  messageDesc(file_container_v1_container, 19)

/**
 * @generated from message container.v1.GetFolderResponse
 */
export type GetFolderResponse = Message<'container.v1.GetFolderResponse'> & {
  /**
   * @generated from field: container.v1.Folder folder = 1;
   */
  folder?: Folder
}

/**
 * Describes the message container.v1.GetFolderResponse.
 * Use `create(GetFolderResponseSchema)` to create a new message.
 */
export const GetFolderResponseSchema: GenMessage<GetFolderResponse> =
  /*@__PURE__*/
  messageDesc(file_container_v1_container, 20)

/**
 * @generated from message container.v1.ListWorkspacesResponse
 */
export type ListWorkspacesResponse = Message<'container.v1.ListWorkspacesResponse'> & {
  /**
   * @generated from field: repeated container.v1.Workspace workspaces = 1;
   */
  workspaces: Workspace[]

  /**
   * @generated from field: common.v1.PaginationPageInfo page_info = 2;
   */
  pageInfo?: PaginationPageInfo
}

/**
 * Describes the message container.v1.ListWorkspacesResponse.
 * Use `create(ListWorkspacesResponseSchema)` to create a new message.
 */
export const ListWorkspacesResponseSchema: GenMessage<ListWorkspacesResponse> =
  /*@__PURE__*/
  messageDesc(file_container_v1_container, 21)

/**
 * @generated from message container.v1.ListFoldersResponse
 */
export type ListFoldersResponse = Message<'container.v1.ListFoldersResponse'> & {
  /**
   * @generated from field: repeated container.v1.Folder folders = 1;
   */
  folders: Folder[]

  /**
   * @generated from field: common.v1.PaginationPageInfo page_info = 2;
   */
  pageInfo?: PaginationPageInfo
}

/**
 * Describes the message container.v1.ListFoldersResponse.
 * Use `create(ListFoldersResponseSchema)` to create a new message.
 */
export const ListFoldersResponseSchema: GenMessage<ListFoldersResponse> =
  /*@__PURE__*/
  messageDesc(file_container_v1_container, 22)

/**
 * @generated from message container.v1.CountFoldersResponse
 */
export type CountFoldersResponse = Message<'container.v1.CountFoldersResponse'> & {
  /**
   * @generated from field: int32 num_folders = 1;
   */
  numFolders: number
}

/**
 * Describes the message container.v1.CountFoldersResponse.
 * Use `create(CountFoldersResponseSchema)` to create a new message.
 */
export const CountFoldersResponseSchema: GenMessage<CountFoldersResponse> =
  /*@__PURE__*/
  messageDesc(file_container_v1_container, 23)

/**
 * @generated from message container.v1.CreateFolderResponse
 */
export type CreateFolderResponse = Message<'container.v1.CreateFolderResponse'> & {
  /**
   * @generated from field: container.v1.Folder folder = 1;
   */
  folder?: Folder
}

/**
 * Describes the message container.v1.CreateFolderResponse.
 * Use `create(CreateFolderResponseSchema)` to create a new message.
 */
export const CreateFolderResponseSchema: GenMessage<CreateFolderResponse> =
  /*@__PURE__*/
  messageDesc(file_container_v1_container, 24)

/**
 * @generated from message container.v1.ArchiveFolderResponse
 */
export type ArchiveFolderResponse = Message<'container.v1.ArchiveFolderResponse'> & {
  /**
   * @generated from field: container.v1.Folder folder = 1;
   */
  folder?: Folder
}

/**
 * Describes the message container.v1.ArchiveFolderResponse.
 * Use `create(ArchiveFolderResponseSchema)` to create a new message.
 */
export const ArchiveFolderResponseSchema: GenMessage<ArchiveFolderResponse> =
  /*@__PURE__*/
  messageDesc(file_container_v1_container, 25)

/**
 * @generated from message container.v1.RestoreFolderResponse
 */
export type RestoreFolderResponse = Message<'container.v1.RestoreFolderResponse'> & {
  /**
   * @generated from field: container.v1.Folder folder = 1;
   */
  folder?: Folder
}

/**
 * Describes the message container.v1.RestoreFolderResponse.
 * Use `create(RestoreFolderResponseSchema)` to create a new message.
 */
export const RestoreFolderResponseSchema: GenMessage<RestoreFolderResponse> =
  /*@__PURE__*/
  messageDesc(file_container_v1_container, 26)

/**
 * @generated from message container.v1.MoveFolderResponse
 */
export type MoveFolderResponse = Message<'container.v1.MoveFolderResponse'> & {
  /**
   * @generated from field: container.v1.Folder folder = 1;
   */
  folder?: Folder
}

/**
 * Describes the message container.v1.MoveFolderResponse.
 * Use `create(MoveFolderResponseSchema)` to create a new message.
 */
export const MoveFolderResponseSchema: GenMessage<MoveFolderResponse> =
  /*@__PURE__*/
  messageDesc(file_container_v1_container, 27)

/**
 * @generated from message container.v1.MoveFoldersResponse
 */
export type MoveFoldersResponse = Message<'container.v1.MoveFoldersResponse'> & {
  /**
   * @generated from field: repeated container.v1.Folder folders = 1;
   */
  folders: Folder[]
}

/**
 * Describes the message container.v1.MoveFoldersResponse.
 * Use `create(MoveFoldersResponseSchema)` to create a new message.
 */
export const MoveFoldersResponseSchema: GenMessage<MoveFoldersResponse> =
  /*@__PURE__*/
  messageDesc(file_container_v1_container, 28)

/**
 * @generated from message container.v1.UpdateFolderResponse
 */
export type UpdateFolderResponse = Message<'container.v1.UpdateFolderResponse'> & {
  /**
   * @generated from field: container.v1.Folder folder = 1;
   */
  folder?: Folder
}

/**
 * Describes the message container.v1.UpdateFolderResponse.
 * Use `create(UpdateFolderResponseSchema)` to create a new message.
 */
export const UpdateFolderResponseSchema: GenMessage<UpdateFolderResponse> =
  /*@__PURE__*/
  messageDesc(file_container_v1_container, 29)

/**
 * @generated from message container.v1.DeleteFolderResponse
 */
export type DeleteFolderResponse = Message<'container.v1.DeleteFolderResponse'> & {}

/**
 * Describes the message container.v1.DeleteFolderResponse.
 * Use `create(DeleteFolderResponseSchema)` to create a new message.
 */
export const DeleteFolderResponseSchema: GenMessage<DeleteFolderResponse> =
  /*@__PURE__*/
  messageDesc(file_container_v1_container, 30)

/**
 * @generated from message container.v1.DeleteFoldersResponse
 */
export type DeleteFoldersResponse = Message<'container.v1.DeleteFoldersResponse'> & {}

/**
 * Describes the message container.v1.DeleteFoldersResponse.
 * Use `create(DeleteFoldersResponseSchema)` to create a new message.
 */
export const DeleteFoldersResponseSchema: GenMessage<DeleteFoldersResponse> =
  /*@__PURE__*/
  messageDesc(file_container_v1_container, 31)

/**
 * @generated from enum container.v1.ContainerType
 */
export enum ContainerType {
  /**
   * @generated from enum value: CONTAINER_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CONTAINER_TYPE_FOLDER = 1;
   */
  FOLDER = 1,

  /**
   * @generated from enum value: CONTAINER_TYPE_WORKSPACE = 2;
   */
  WORKSPACE = 2,

  /**
   * @generated from enum value: CONTAINER_TYPE_ORG = 3;
   */
  ORG = 3
}

/**
 * Describes the enum container.v1.ContainerType.
 */
export const ContainerTypeSchema: GenEnum<ContainerType> =
  /*@__PURE__*/
  enumDesc(file_container_v1_container, 0)

/**
 * @generated from enum container.v1.FolderState
 */
export enum FolderState {
  /**
   * @generated from enum value: FOLDER_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: FOLDER_STATE_ACTIVE = 1;
   */
  ACTIVE = 1,

  /**
   * @generated from enum value: FOLDER_STATE_DRAFT = 2;
   */
  DRAFT = 2,

  /**
   * @generated from enum value: FOLDER_STATE_ARCHIVED = 3;
   */
  ARCHIVED = 3
}

/**
 * Describes the enum container.v1.FolderState.
 */
export const FolderStateSchema: GenEnum<FolderState> =
  /*@__PURE__*/
  enumDesc(file_container_v1_container, 1)

/**
 * Public APIs
 *
 * @generated from service container.v1.ContainerService
 */
export const ContainerService: GenService<{
  /**
   * // Mutations
   *
   * @generated from rpc container.v1.ContainerService.CreateFolder
   */
  createFolder: {
    methodKind: 'unary'
    input: typeof CreateFolderRequestSchema
    output: typeof CreateFolderResponseSchema
  }
  /**
   * @generated from rpc container.v1.ContainerService.UpdateFolder
   */
  updateFolder: {
    methodKind: 'unary'
    input: typeof UpdateFolderRequestSchema
    output: typeof UpdateFolderResponseSchema
  }
  /**
   * @generated from rpc container.v1.ContainerService.ArchiveFolder
   */
  archiveFolder: {
    methodKind: 'unary'
    input: typeof ArchiveFolderRequestSchema
    output: typeof ArchiveFolderResponseSchema
  }
  /**
   * @generated from rpc container.v1.ContainerService.RestoreFolder
   */
  restoreFolder: {
    methodKind: 'unary'
    input: typeof RestoreFolderRequestSchema
    output: typeof RestoreFolderResponseSchema
  }
  /**
   * @generated from rpc container.v1.ContainerService.DeleteFolder
   */
  deleteFolder: {
    methodKind: 'unary'
    input: typeof DeleteFolderRequestSchema
    output: typeof DeleteFolderResponseSchema
  }
  /**
   * @generated from rpc container.v1.ContainerService.DeleteFolders
   */
  deleteFolders: {
    methodKind: 'unary'
    input: typeof DeleteFoldersRequestSchema
    output: typeof DeleteFoldersResponseSchema
  }
  /**
   * @generated from rpc container.v1.ContainerService.MoveFolder
   */
  moveFolder: {
    methodKind: 'unary'
    input: typeof MoveFolderRequestSchema
    output: typeof MoveFolderResponseSchema
  }
  /**
   * @generated from rpc container.v1.ContainerService.MoveFolders
   */
  moveFolders: {
    methodKind: 'unary'
    input: typeof MoveFoldersRequestSchema
    output: typeof MoveFoldersResponseSchema
  }
  /**
   * // Queries
   *
   * @generated from rpc container.v1.ContainerService.GetOrg
   */
  getOrg: {
    methodKind: 'unary'
    input: typeof GetOrgRequestSchema
    output: typeof GetOrgResponseSchema
  }
  /**
   * @generated from rpc container.v1.ContainerService.GetWorkspace
   */
  getWorkspace: {
    methodKind: 'unary'
    input: typeof GetWorkspaceRequestSchema
    output: typeof GetWorkspaceResponseSchema
  }
  /**
   * @generated from rpc container.v1.ContainerService.GetFolder
   */
  getFolder: {
    methodKind: 'unary'
    input: typeof GetFolderRequestSchema
    output: typeof GetFolderResponseSchema
  }
  /**
   * @generated from rpc container.v1.ContainerService.ListWorkspaces
   */
  listWorkspaces: {
    methodKind: 'unary'
    input: typeof ListWorkspacesRequestSchema
    output: typeof ListWorkspacesResponseSchema
  }
  /**
   * @generated from rpc container.v1.ContainerService.ListFolders
   */
  listFolders: {
    methodKind: 'unary'
    input: typeof ListFoldersRequestSchema
    output: typeof ListFoldersResponseSchema
  }
  /**
   * @generated from rpc container.v1.ContainerService.CountFolders
   */
  countFolders: {
    methodKind: 'unary'
    input: typeof CountFoldersRequestSchema
    output: typeof CountFoldersResponseSchema
  }
}> = /*@__PURE__*/ serviceDesc(file_container_v1_container, 0)
